import React, { useState, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import AuthContext from "../../context/AuthContext";
import { createTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import { getCSRFToken } from "../../utils/helperFunctions";

const ProfileEditForm = ({ profile }) => {
  let { user } = useContext(AuthContext);
  const userID = user["user_id"];

  const [open, setOpen] = useState(false);
  const [newProfile, setNewProfile] = useState({
    bio: profile.bio,
    avatar: null,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProfile = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("bio", newProfile.bio);
    if (newProfile.avatar) {
      formData.append("avatar", newProfile.avatar);
    }

    const response = await fetch(`/api/updateProfile/${userID}`, {
      method: "POST",
      headers: {
        "X-CSRFToken": getCSRFToken(),
      },
      body: formData,
    });

    await response.json();
    if (response.ok) {
      window.location.reload();
    }
  };

  return (
    <div>
      <Grid container justifyContent="flex-end">
        <IconButton aria-label="edit" size="large" onClick={handleClickOpen}>
          <EditIcon />
        </IconButton>
      </Grid>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <form onSubmit={handleProfile} id="profile-edit-form">
          <DialogTitle>Profil bearbeiten</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Du kannst gerne deine Bio verändern!
            </DialogContentText>
            <TextField
              required
              autoFocus
              margin="dense"
              id="bio"
              name="Bio"
              label="Biographie"
              type="text"
              fullWidth
              variant="standard"
              multiline
              rows={4}
              defaultValue={profile?.bio}
              onChange={(e) =>
                setNewProfile({
                  ...newProfile,
                  bio: e.target.value,
                })
              }
            />
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="avatar-upload"
              type="file"
              onChange={(e) =>
                setNewProfile({
                  ...newProfile,
                  avatar: e.target.files[0],
                })
              }
            />
            <label htmlFor="avatar-upload">
              <Button variant="contained" component="span">
                Avatar hochladen
              </Button>
            </label>
          </DialogContent>

          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={handleClose}>
                Abbrechen
              </Button>
              <Button variant="contained" type="submit">
                Speichern
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default ProfileEditForm;
